import { createSwitchingStatusComposable } from '@/composables/create-switching-status-composable';

/**
 * Provides unclustered switching job progress/cann-group status for display, via one
 * of two mechanisms selected by the `switching.usePollingForUpdates` feature flag:
 *  - Polling (flag on): actively fetches `/switching-service-job/status` on an interval.
 *  - Push (flag off, default): reads data already kept fresh in the scenarios store by
 *    the Dapr-driven statusUpdate SSE push (see stores/events.js).
 *
 * Auto-resumes polling on mount if a job is already in progress (polling mode only).
 * In push mode, fires a one-off reconciliation request on mount instead, so a job left
 * stuck by a missed/dropped Dapr event is corrected on page load. Stops on unmount.
 *
 * Returns `serviceJobCannGroups` — an array of cann group objects each with `cannGroupId`,
 * `name`, and `status` — so callers can render granular per-cann-group progress breakdowns.
 */
export const useUnclusteredSwitchingStatus = createSwitchingStatusComposable({
  statusUrl: id => `/api/scenarios/${id}/switching-service-job/status`,
  getJobStatus: jobStatuses => jobStatuses?.switching,
  getPollingDetails: statusData => statusData?.cannGroups,
  getPushDetails: status => status?.extra?.cannGroups,
  detailsKey: 'serviceJobCannGroups',
});
